import { useUserStore } from "~/stores/user";

const whitelist = ["/", "/signup", "/setup", "/login", "/kiosk"];
const either = ["/leaderboard", "/photos"];

export default defineNuxtRouteMiddleware(async (to, from) => {
  const token = useCookie("player-portal-token").value;
  const user = useUserStore();
  const isWhitelisted = whitelist.some(
    (path) => to.path === path || to.path.startsWith(path + "/")
  );

  if (to.path === "/home" && to.query.source === "qr") {
    console.log("QR login attempt...");
    const key = Array.isArray(to.query.key) ? to.query.key[0] : to.query.key;
    const rawId = Array.isArray(to.query.id) ? to.query.id[0] : to.query.id;
    const idNumber = Number(rawId);
    if (key && Number.isFinite(idNumber) && idNumber > 0) {
      await user.loginWithKey(key, idNumber, { silent: true });
      if (user.loggedIn) {
        return navigateTo("/home", { replace: true });
      }
    }
    return navigateTo("/login");
  }

  if (!isWhitelisted) {

    if (either.includes(to.path)) {
      if (token) {
        if (!user.playerId) {
          await user.getUserInfo();
        }
      }
    } else {
      if (!token) {
        return navigateTo("/login");
      } else {
        if (!user.playerId) {
          await user.getUserInfo();
        }
      }
    }
  }
});
